import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Container,
  Divider,
  Stack,
  Typography,
  Fade,
} from "@mui/material";

import { useTranslation, Trans } from "react-i18next";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { forwardRef } from "react";



export default function Faq() {
  const { t, i18n } = useTranslation();

  const FadeTransition = forwardRef(function FadeTransition(props, ref) {
    return <Fade ref={ref} {...props} />;
  });

  const questions = [
    {
      title: t("Help me now!"),
      questions: [
        {
          title:
            t("My bet is not showing on the history page after I completed the transaction and I don't know if I won or lost. What can I do?"),
          text: t("First of all, make sure the bet went through on your side by checking your web3 wallet. If the issue is not on your end, it may be possible the betting transaction got stuck in the respective blockchain (Optimism, Polygon, BSC, Arbitrum). Do not worry as we detect the problematic transactions on our side meaning we will refund you the transaction in the next 1 to 24 hours. You may ask for help on Discord for more information."),
        },
        {
          title:
            t("I cannot connect my wallet on nice2win on mobile. How can I play?"),
          text: t("You need to use a browser such as the Metamask app or the Brave app to play on nice2win from your mobile device."),
        },
        {
          title:
            t("The platform is not working correctly and I cannot play the games. What should I do?"),
          text: t("Make sure your wallet is active and connected to the platform. Contact us on Discord and we'll be happy to help."),
        },
      ],
    },
    {
      title: t("The Basics"),
      questions: [
        {
          title: t("What is provably fair on-chain gambling?"),
          text: t("Provably fair means any bet outcome can be independently verified and is tamper-proof."),
        },
        {
          title: t("How does a decentralized casino work?"),
          text: t("nice2win uses smart contracts to process game outcomes. Anyone can access the platform and place bets using cryptocurrencies. The use of smart contracts allows for the automatic execution of the terms of the bet, ensuring that the outcome is fair and transparent."),
        },
        {
          title: t("Is it safe to play on nice2win?"),
          text: t("nice2win offers higher security and transparency compared to traditional casinos due to the use of blockchain technology."),
        },
        {
          title:
          t("How does a web3 casino platform differ from a traditional online casino?"),
          text: t("A web3 casino platform operates on a decentralized network, meaning it is not controlled by a central authority. This allows for greater transparency and security compared to traditional online casinos, which may be subject to fraud or manipulation."),
        },
      ],
    },
    {
      title: "The Specifics",
      questions: [
        {
          title: "What currencies do you accept?",
          text: "You can place bets using MATIC on Polygon, BNB on Binance Smart Chain, and ETH on Optimism or Arbitrum. We are working on adding more currencies in the future.",
        },
        {
          title: "Do I have to register in order to play?",
          text: "You do not have to register as we support fully anonymous players. If you choose to register, you will need an email address to link to a web3 address.",
        },
        {
          title: "Can I play on nice2win from mobile, desktop or tablet?",
          text: "We fully support mobile, desktop and tablet. If you are playing on a mobile device or a tablet device, we recommend the Metamask app or the Brave app as browser.",
        },
        {
          title: "What is the $N2W token and what can I do with it?",
          text: "The $N2W token is an upcoming token created by nice2win. For now, we are keeping the data relating the token in our centralized database and we will retroactively reward addresses with their corresponding $N2W once we deploy the ERC-20 smart contract. The utility of $N2W on the platform remains to be fully decided although it will be spendable and usable on nice2win.",
        },
        {
          title: "How can I earn and sell $N2W?",
          text: "You can earn $N2W through every bet you make on nice2win, whether you win or lose. You can also qualify for airdrops if you participate on our Twitter and Discord. You can't sell $N2W yet because it does not exist in its ERC-20 form. After we publish the ERC-20 contract, we will need to provide a liquidity pool on a DEX such as Uniswap for people to sell/buy.",
        },
        {
          title: "Do I have to send funds in order to play?",
          text: "Players hold funds in their self-custodial web3 wallets. To be clear, we will NEVER have control over your wallet funds if you decide to step away.",
        },
        {
          title: "How can I be sure I will receive my payout if I win?",
          text: "The game contract is programmed in such a way to only accept bets that it can afford to payout. You can also keep track of your winnings on your account's profile.",
        },
        {
          title: "Which network does nice2win recommend for better experience?",
          text: "Optimism offers faster settlement times and lower transaction fees. Alternatively, Polygon, Arbitrum and BSC are perfectly valid options.",
        },
        // {
        //   title: "Will you deploy to Ethereum?",
        //   text: "We are open to deploying on the Ethereum blockchain in the future after the full 2.0 upgrade.",
        // },
        {
          title: "What are the fees associated with each bet?",
          text: "nice2win only charges 1% house edge with a mimimum fee to cover for the gas",
        },
        {
          title: "How does the jackpot work?",
          text: "For ETH bets, starting from 0.03 ETH, 0.0003 ETH gets accumulated in the jackpot with a 0.01% chance per bet. For MATIC bets, starting from bets of 30 MATIC and more, 0.1 MATIC gets accumulated in the jackpot with a 0.01% chance per bet. For BNB bets, starting from bets of 0.05 BNB and more, 0.005 BNB gets accumulated in the jackpot with a 0.01% chance per bet.",
        },
      ],
    },
    {
      title: t("Ecosystem"),
      questions: [
        {
          title: t("Which wallets are compatible with nice2win?"),
          text: t("A web3 wallet connected to your browser is required to unlock the main functionalities including submitting a transaction to bet. We currently support Metamask, WalletConnect (which is a wallet aggregator) and Coinbase Wallet."),
        },
        {
          title: t("How do I move funds accross blockchains?"),
          text: t("In order to bridge funds over on to one blockchain from another blockchain, we recommend the Bungee Bridge at https://www.bungee.exchange as it offers best routes to bridge assets."),
          //or Polygon //and MATIC
        },
        {
          title: t("Where do I get ETH, MATIC or BNB to play your games?"),
          text: t("To convert ETH/MATIC/BNB to another currency or vice-versa, we recommend using Decentralized Exchanges such as Uniswap.org or Sushi.com"),
          // As for Polygon, our personal favorite is Quickswap located at https://quickswap.exchange which offers good pairs and liquidity.",
        },
        {
          title: t("How can I play if I only have funds in BTC?"),
          text: t("To transfer funds from a blockchain that is not compatible with the bridges offered on Bungee, we recommend that you use Flyp.me to transfer coins such as BTC or XMR from their native blockchain to Ethereum (or Binance Smart Chain for lower fees)!"),
        },
      ],
    },
  ];

  return (
    <Box>
      <Container>
        <Stack spacing={4}>
          <Typography fontSize="large"><Trans t={t}>FAQ</Trans></Typography>
          <Divider />
          <Stack spacing={2} >
            {questions.map((group, groupIndex) => (
              <div key={groupIndex}>
                <Typography>{t(group.title)}</Typography>
                <Stack>
                  {group.questions.map((question, questionIndex) => (
                    <Accordion key={questionIndex} TransitionComponent={FadeTransition}
                      TransitionProps={{ timeout: 700, enter: true, exit: false, unmountOnExit: true }}>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                        sx={{
                          boxShadow: '0 3px 10px rgba(0, 0, 0, 0.2)',
                          borderRadius: 4,
                        }}
                      >
                        <Typography sx={{ overflowWrap: "anywhere" }}>
                          {t(question.title)}
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Typography>{t(question.text)}</Typography>
                      </AccordionDetails>
                    </Accordion>
                  ))}
                </Stack>
              </div>
            ))}
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
}
